import {
  WHITE_LIST_MIME_IMAGE,
  WHITE_LIST_MIME_AUDIO,
  WHITE_LIST_MIME_VIDEO,

  WHITE_LIST_MIME_FILE_DOCS,
  WHITE_LIST_MIME_FILE_PRESENTATION,
  WHITE_LIST_MIME_FILE_SHEET,

  WHITE_LIST_MIME_FILE_TEXT,
  WHITE_LIST_MIME_FILE_ARCHIVE,
  WHITE_LIST_MIME_PDF,
  WHITE_LIST_MIME_CODE
} from './mimetype'

/**
 * This function generate Blod file
 * @param {String} mimetype 
 * @param {String} type  - link or file
 */
const generateBlod = (mimetype, type) => {

  let blod = ''
  if (type === 'link') {
    blod = 'link'
  } else if (type === 'error') {
    blod = 'exclamation-triangle'
  } else if (type === 'more') {
    blod = 'ellipsis-h'
  } else if (  type === 'file') {
    blod = 'file'

    if (WHITE_LIST_MIME_FILE_SHEET.includes(mimetype)) {
      blod = 'file-excel'
    }

    if (WHITE_LIST_MIME_FILE_PRESENTATION.includes(mimetype)) {
      blod = 'file-powerpoint'
    }

    if (WHITE_LIST_MIME_FILE_DOCS.includes(mimetype)) {
      blod = 'file-word'
    }

    if (WHITE_LIST_MIME_IMAGE.includes(mimetype)) {
      blod = 'image'
    }

    if (WHITE_LIST_MIME_VIDEO.includes(mimetype)) {
      blod = 'video'
    }

    if (WHITE_LIST_MIME_AUDIO.includes(mimetype)) {
      blod = 'music'
    }

    if (WHITE_LIST_MIME_FILE_ARCHIVE.includes(mimetype)) {
      blod = 'file-archive'
    }

    if (WHITE_LIST_MIME_FILE_TEXT.includes(mimetype)) {
      blod = 'file-alt'
    }

    if (WHITE_LIST_MIME_PDF.includes(mimetype)) {
      blod = 'file-pdf'
    }

    if (WHITE_LIST_MIME_CODE.includes(mimetype)) {
      blod = 'file-code'
    }

    if (['text/csv'].includes(mimetype)) {
      blod = 'file-csv'
    }

  }

  return blod
}

/**
 * This function generate class name style for blod file
 * @param {String} mimetype 
 * @param {String} type  - link or file
 */
const classnameIcon = (mimetype, type) => {
  if (type === 'more') {
    return '#616161'
  } else if (type === 'error') {
    return 'var(--destructive)'
  } else if (type === 'link') {
    return 'rgb(215, 128, 0)'
  } else {
    if (mimetype) {

      if ([...WHITE_LIST_MIME_FILE_SHEET, 'text/csv'].includes(mimetype)) {
        return 'rgba(19, 97, 22, 0.842)'
      }

      if (WHITE_LIST_MIME_FILE_PRESENTATION.includes(mimetype)) {
        return 'rgb(250, 79, 1)'
      }

      if (WHITE_LIST_MIME_FILE_DOCS.includes(mimetype)) {
        return 'rgb(50, 102, 139)'
      }

      if (WHITE_LIST_MIME_IMAGE.includes(mimetype)) {
        return 'rgb(149, 95, 220)'
      }

      if (WHITE_LIST_MIME_VIDEO.includes(mimetype)) {
        return 'rgb(198, 174, 230)'
      }

      if (WHITE_LIST_MIME_AUDIO.includes(mimetype)) {
        return 'rgba(82, 214, 86, 0.842)'
      }

      if (WHITE_LIST_MIME_PDF.includes(mimetype)) {
        return 'rgb(255, 0, 0)'
      }

      if (WHITE_LIST_MIME_FILE_TEXT.includes(mimetype)) {
        return 'rgb(0, 55, 77)'
      }

      if (WHITE_LIST_MIME_FILE_ARCHIVE.includes(mimetype)) {
        return 'rgb(51, 51, 51)'
      }

      if (WHITE_LIST_MIME_CODE.includes(mimetype)) {
        return 'rgb(59, 59, 59)'
      }
  
    } else {
      return 'var(--muted-foreground)'
    }
  }
}


/**
 * This function generate width preview dialog
 * @param {String} mimetype 
 */
const generateWidthPreview = (mimetype) => {
  if (WHITE_LIST_MIME_IMAGE.includes(mimetype)) {
    return 'auto'
  }

  if (WHITE_LIST_MIME_AUDIO.includes(mimetype)) {
    return 300
  }


  if (WHITE_LIST_MIME_VIDEO.includes(mimetype)) {
    return 700
  }
  return 1500
}

/**
 * This function generate height preview dialog
 * @param {String} mimetype 
 */
const generarteHeight = (mimetype) => {
  if (WHITE_LIST_MIME_AUDIO.includes(mimetype)) {
    return 'auto'
  }
  
  if (WHITE_LIST_MIME_VIDEO.includes(mimetype)) {
    return 400
  }

  return 800
}


/**
 * This function gropup files array by mimetype
 * @param {Array} array 
 */
const groupArrayByMimetype = (array = []) => {
  let data = []
  let info = {}

  array.forEach((item) => {
    if (WHITE_LIST_MIME_FILE_SHEET.includes(item.mimetype)) {
      info[WHITE_LIST_MIME_FILE_SHEET[0]] = info[WHITE_LIST_MIME_FILE_SHEET[0]] ? [...info[WHITE_LIST_MIME_FILE_SHEET[0]],  item] : [item]
    }

    if (WHITE_LIST_MIME_FILE_PRESENTATION.includes(item.mimetype)) {
      info[WHITE_LIST_MIME_FILE_PRESENTATION[0]] = info[WHITE_LIST_MIME_FILE_PRESENTATION[0]] ? [...info[WHITE_LIST_MIME_FILE_PRESENTATION[0]],  item] : [item]
    }

    if (WHITE_LIST_MIME_FILE_DOCS.includes(item.mimetype)) {
      info[WHITE_LIST_MIME_FILE_DOCS[0]] = info[WHITE_LIST_MIME_FILE_DOCS[0]] ? [...info[WHITE_LIST_MIME_FILE_DOCS[0]],  item] : [item]
    }

    if (WHITE_LIST_MIME_IMAGE.includes(item.mimetype)) {
      info[WHITE_LIST_MIME_IMAGE[0]] = info[WHITE_LIST_MIME_IMAGE[0]] ? [...info[WHITE_LIST_MIME_IMAGE[0]],  item] : [item]
    }

    if (WHITE_LIST_MIME_VIDEO.includes(item.mimetype)) {
      info[WHITE_LIST_MIME_VIDEO[0]] =  info[WHITE_LIST_MIME_VIDEO[0]] ? [...info[WHITE_LIST_MIME_VIDEO[0]],  item] : [item]
    }

    if (WHITE_LIST_MIME_AUDIO.includes(item.mimetype)) {
      info[WHITE_LIST_MIME_AUDIO[0]] =  info[WHITE_LIST_MIME_AUDIO[0]] ? [...info[WHITE_LIST_MIME_AUDIO[0]],  item] : [item]
    }

    if (WHITE_LIST_MIME_FILE_TEXT.includes(item.mimetype)) {
      info[WHITE_LIST_MIME_FILE_TEXT[0]] =  info[WHITE_LIST_MIME_FILE_TEXT[0]] ? [...info[WHITE_LIST_MIME_FILE_TEXT[0]],  item] : [item]
    }

    if (WHITE_LIST_MIME_FILE_ARCHIVE.includes(item.mimetype)) {
      info[WHITE_LIST_MIME_FILE_ARCHIVE[0]] =  info[WHITE_LIST_MIME_FILE_ARCHIVE[0]] ? [...info[WHITE_LIST_MIME_FILE_ARCHIVE[0]],  item] : [item]
    }

    if (WHITE_LIST_MIME_PDF.includes(item.mimetype)) {
      info[WHITE_LIST_MIME_PDF[0]] =  info[WHITE_LIST_MIME_PDF[0]] ? [...info[WHITE_LIST_MIME_PDF[0]],  item] : [item]
    }

    if (WHITE_LIST_MIME_CODE.includes(item.mimetype)) {
      info[WHITE_LIST_MIME_CODE[0]] =  info[WHITE_LIST_MIME_CODE[0]] ? [...info[WHITE_LIST_MIME_CODE[0]],  item] : [item]
    }
    if (['text/csv'].includes(item.mimetype)) {
      info['text/csv'] =  info['text/csv'] ? [...info['text/csv'],  item] : [item]
    }
  })


  Object.keys(info).forEach((key) => {
    if (info[key].length > 0) {
      data.push({
        group: key,
        items: info[key]
      })
    }
  })


  return data
}

export {
  generateBlod, classnameIcon, generateWidthPreview, generarteHeight, groupArrayByMimetype
}